<template>
  <div>
    <Carousel :images="activity.images.data" ></Carousel>
    <div class="basePrice" v-if="activity.base_price">{{t('from')}} {{activity.base_price}} € <span v-if="activity.is_priced_per_occurrence">/ {{t('group')}}</span></div>
  </div>
</template>


<script>
import { mapState } from 'vuex';
import Carousel from '../Carousel';

export default {
  name: 'ActivityImages',
  components: {
    Carousel,
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapState({
      language: state => state.language,
      activity: state => state.activityPublic.activity,
    }),

  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/variables-b4";
@import "../../../static/MDB-PRO/sass/mdb/free/data/colors";
@import "../../assets/scss/variables";
/* 1.  ALL SCREENS*/

.basePrice {
  background-color: $brand-primary;
  color: white;
  text-align: right;
  padding: 6px 12px;
  position: absolute;
  right: 6px;
  bottom: 32px;
  z-index: 1;
  font-size: 13px;
}

/* Small Screen 544px */
@media only screen and (min-width: map-get($grid-breakpoints, sm)) {

}

/* Small Devices, Tablets 768px */
@media only screen and (min-width: map-get($grid-breakpoints, md)) {

}

/* Medium Devices, Desktops */
@media only screen and (min-width: map-get($grid-breakpoints, lg)) {

}

/* Large Devices, Wide Screens  1200px */
@media only screen and (min-width: map-get($grid-breakpoints, xl)) {

}

</style>



// WEBPACK FOOTER //
// ActivityImages.vue?ca970ad0